import type { PointerEvent } from 'react';

/**
 * Indicates if the specified event is for the primary pointing device.
 *
 * @param event - The event to check.
 * @returns `true` if the event is for the primary pointing device; otherwise, `false`.
 */
export const isPrimaryPointer = (event: PointerEvent): boolean =>
  event.pointerType === 'mouse' && event.isPrimary;
